import axios from 'axios'
import { useErrorHandling } from '@/composables'
import { ENDPOINTS } from '@/endpoints'
import type { GenericAbortSignal } from 'axios'
import type { APIResponse, BranchSearchResult } from '@/types'

export const searcBranches = async (
    searchTerm: string,
    signal?: GenericAbortSignal
) => {
    const request = axios.get<APIResponse<BranchSearchResult[]>>(
        `${ENDPOINTS.BRANCHES}/search`, 
        {
            params: { searchTerm },
            signal,
        }
    )

    const response = await useErrorHandling(request)

    return response.data.data
}
